"use client";

import { useState } from "react";
import TableOfContents from "./TableOfContents";

export default function CollapsibleToc({ content }: { content: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <button
        onClick={() => setOpen(!open)}
        className="flex items-center justify-between w-full bg-transparent border-none p-0 cursor-pointer font-semibold uppercase text-xs tracking-widest text-muted-foreground"
      >
        <span>Contents</span>
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          className={`text-muted-foreground transition-transform duration-200 ${open ? "rotate-180" : "rotate-0"}`}
        >
          <path
            d="M3.5 5.25L7 8.75L10.5 5.25"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <div
        className="overflow-hidden transition-all duration-300"
        style={{
          maxHeight: open ? "500px" : "0px",
          marginTop: open ? "12px" : "0px",
        }}
      >
        <TableOfContents content={content} />
      </div>
    </div>
  );
}
